
/*
|  ######   #######  ##     ## ##    ## ######## ########   #######  ##      ## ##    ##
| ##    ## ##     ## ##     ## ###   ##    ##    ##     ## ##     ## ##  ##  ## ###   ##
| ##       ##     ## ##     ## ####  ##    ##    ##     ## ##     ## ##  ##  ## ####  ##
| ##       ##     ## ##     ## ## ## ##    ##    ##     ## ##     ## ##  ##  ## ## ## ##
| ##       ##     ## ##     ## ##  ####    ##    ##     ## ##     ## ##  ##  ## ##  ####
| ##    ## ##     ## ##     ## ##   ###    ##    ##     ## ##     ## ##  ##  ## ##   ###
|  ######   #######   #######  ##    ##    ##    ########   #######   ###  ###  ##    ##
|
| ######## #### ##     ## ######## ########
|    ##     ##  ###   ### ##       ##     ##
|    ##     ##  #### #### ##       ##     ##
|    ##     ##  ## ### ## ######   ########
|    ##     ##  ##     ## ##       ##   ##
|    ##     ##  ##     ## ##       ##    ##
|    ##    #### ##     ## ######## ##     ##

https://albert-gonzalez.github.io/easytimer.js/
*/

import Timer from 'easytimer.js';
// const timer = new Timer();

let countdown = document.querySelector('.js-countdown');

if ( countdown )
{
	var timer = new Timer(),
		time = countdown.querySelector('.time'),
		end = countdown.dataset.end,
		format = countdown.dataset.format,
		timeString = null,
		startSeconds = countdown.dataset.seconds;

		console.log({time});

	timer.start({countdown: true, startValues: {seconds: startSeconds}});

	function timerString(startSeconds, format)
	{
		// var html = null;
		var h = timer.getTimeValues().hours,
			m = timer.getTimeValues().minutes,
			s = timer.getTimeValues().seconds;

		switch (format)
		{
			case 'numeric':
				timeString = [h, m, s].join(":");
				if (startSeconds < 60*60)
				{
					timeString = [m, s].join(":")
				}
			break;

			case 'textual':

				timeString = '';

				// Hours
				if (startSeconds > 60*60)
				{
					timeString += h + ' hour';
					if (h != 1) timeString += 's';
					timeString +=', ';
				}

				// Minutes
				timeString += m + ' minute';
				if (m != 1) timeString += 's';

				// Seconds
				timeString += ' & ' + s + ' second';
				if (s != 1) timeString += 's';

			break;

			default:
				break;
		}

		return timeString;
	}

	// time.html( timerString(startSeconds, format) );


	timer.addEventListener('secondsUpdated', () => {
		time.innerHTML = timerString(startSeconds, format);
	});
	timer.addEventListener('targetAchieved', () => {
		countdown.innerHTML = end;
	});

}